module.exports = __webpack_public_path__ + "static/img/trade-icon1.6224f81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trade-icon1.png
// module id = +amM
// module chunks = 0